<div class="bottom-sheet-shop-list">
  <div class="bottom-sheet-shop-list-address-suggestions-select">
    <ui-address-suggestions-select
      [placeholder]="placeholder"
      (handleOpened)="handleIsOpened($event)"
      (changeAddress)="handleAddressChange($event)"
    ></ui-address-suggestions-select>
  </div>
  <div class="bottom-sheet-shop-list-content">
    @if (!isOpened()) {
      @if (shopsSorted$ | async; as shopsSorted) {
        <div #shopListRef class="bottom-sheet-shop-list-content-inner">
          <sd-shop-list [shops]="shopsSorted" (clickShop)="handleShopClick($event)"></sd-shop-list>
        </div>
      }
    }
  </div>
</div>
